// src/components/BusinessLoanSection.js
import "./BusinessLoan.css";
import React, { useState, useEffect, useMemo } from "react";
import Calculator from "../common/calculator";
import Banklist from "../common/Banklist/Banklist";
import LoanForm from "../common/Form/Form";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";
import { useNavigate } from "react-router-dom";

const BusinessLoanSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="loan-feature-wrapper">
        <div className="container">
          <div className="business-loan-grid">
            {/* Left Side: Static Image */}
            <div className="image-column">
              <div className="loan-image-container">
                <img
                  src="/images/bl5.png"
                  alt="Business Loan Agreement"
                  className="loan-main-img"
                />
              </div>
            </div>

            {/* Right Side: Text Content */}
            <div className="content-column">
              <h3 className="loan-title">
                <span className="bg-blue">Fuel Your Business</span>
                <br />
                <span className="bg-blue">Growth </span>
                <br />
                <span className="bg">Finconcept</span>
              </h3>

              <ul className="loan-features">
                <li>Quick Access to Capital</li>
                <li>Flexible Terms</li>
                <li>Attractive Interest Rates</li>
              </ul>

              <p className="loan-text">
                Offering premium lending solutions, Finconcept assists diverse
                clients via comprehensive business loan services. Bridging the
                gap between lenders and loan providers, we ensure lightning-fast
                processing of business loans with minimal documentation and
                maximum efficacy.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="loan-usage-section">
        <div className="loan-container">
          <div className="loan-left">
            <h2>
              Grow Your Business with a <span>Business Loan</span>
            </h2>

            <p>
              A business loan helps entrepreneurs and companies access funds to
              expand operations, manage working capital, and invest in new
              opportunities. With flexible repayment options, it becomes easier
              to support and grow your business.
            </p>

            <p>
              <strong>Krishana Finconcept Services</strong> offers fast and
              reliable business loan solutions with quick approvals, minimal
              documentation, and competitive interest rates to help you achieve
              your business goals.
            </p>
          </div>

          <div className="loan-right">
            <div className="loan-card">
              <h4>Business Expansion</h4>
              <p>
                Get funding to expand your operations, open new branches, or
                grow your business reach.
              </p>
            </div>

            <div className="loan-card">
              <h4>Working Capital</h4>
              <p>
                Manage daily operational expenses such as salaries, rent, and
                inventory purchases.
              </p>
            </div>

            <div className="loan-card">
              <h4>Equipment Purchase</h4>
              <p>
                Invest in new machinery, tools, or technology to improve
                business productivity.
              </p>
            </div>

            <div className="loan-card">
              <h4>Inventory Management</h4>
              <p>
                Maintain sufficient stock levels to meet customer demand and
                increase sales.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="homeload-main-section homeloan-section modern-variant unique-hero-design full-width-layout">
        <div className="homeloan-hero-text animated-entrance">
          {/* 1. Badge */}
          <div className="badge-glow animated-item">
            Corporate Growth Partner
          </div>

          {/* 2. Main Title */}
          <h1 className="title animated-item">
            Achieve Your Business Goals With Our <span>Business Loans!</span>
          </h1>

          {/* 3. Features Pills */}
          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> Flexible Repayment
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Competitive Interest Rates
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Expert Financial Guidance
            </div>
          </div>

          {/* 4. Description Body */}
          <div className="content-body animated-item">
            <p className="subtitle">
              Turn your business ideas into reality with our reliable Business
              Loan services. <strong>Krishana Finconcept</strong> has partnered
              with leading banks and financial institutions to provide fast and
              hassle-free funding solutions for businesses of all sizes.
            </p>

            <p className="subtitle">
              Whether you are expanding your operations, managing working
              capital, purchasing equipment, or investing in new opportunities,
              we ensure a smooth and efficient process tailored to help your
              business grow successfully.
            </p>
          </div>

          {/* 5. Action Button */}
          <div className="cta-wrapper animated-item">
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/4", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Business Loan</span>
              <div className="btn-glow-shimmer"></div>
            </button>
          </div>
        </div>
      </section>

      <TestimonialsSection />

      <Services
        slug="4"
        title=" Business loan EMI Calculator – Calculate Your Monthly EMI Online
"
      />
    </>
  );
};

export default BusinessLoanSection;
